import React from 'react';
import PropTypes from 'prop-types';
import CallDetailsCount from './CallDetailsCount';
import CallDetailsTable from './CallDetailsTable';
import { Badge, BadgeList } from '../reporting_utils/Badge';

function ScheduledCallDetails({ reportData, domainSettings, locationNames, groupNames }) {
  const { filtered_call_details, filtered_call_details_counts } = reportData;

  const { isAutomotiveIndustry } = domainSettings;

  return (
    <div className='report-details-container'>
      <div className='applied-filters-container'>
        {groupNames.length > 0 ? (
          <BadgeList title='Selected groups' maxLength={3}>
            {groupNames.map((name) => (
              <Badge label={name} key={name} />
            ))}
          </BadgeList>
        ) : null}
        {locationNames.length > 0 ? (
          <BadgeList title='Selected locations' maxLength={3}>
            {locationNames.map((name) => (
              <Badge label={name} key={name} />
            ))}
          </BadgeList>
        ) : null}
      </div>
      <CallDetailsCount callData={filtered_call_details_counts.data} />
      <CallDetailsTable
        isAutomotiveIndustry={isAutomotiveIndustry}
        tableData={filtered_call_details.data}
      />
    </div>
  );
}

ScheduledCallDetails.propTypes = {
  reportData: PropTypes.exact({
    filtered_call_details: PropTypes.object.isRequired,
    filtered_call_details_counts: PropTypes.object.isRequired,
  }).isRequired,
  domainSettings: PropTypes.exact({
    isAutomotiveIndustry: PropTypes.bool.isRequired,
    isTextingEnabled: PropTypes.bool.isRequired,
  }).isRequired,
  locationNames: PropTypes.array.isRequired,
  groupNames: PropTypes.array.isRequired,
};

export default ScheduledCallDetails;
